<div class="menu-wrapper z-3" (mouseleave)="onMouseLeaveWrapper()">
  <div [class.menu-display]="menuDisplay">
    <div class="contents">
      <div class="menu">
        @if(isLoggedIn) {
        <!-- Boucle sur les éléments du menu -->
        @for (item of items; track item) {
        <div
          class="menu-item"
          (click)="setClickedIcon(item)"
          (mouseenter)="onMouseOver(item)"
          (click)="showSubMenu(item)"
          [ngClass]="{
            'item-clicked': isIconClicked(item),
            'orange-border-left': item.isSubItemClicked
          }"
          [routerLink]="item.link ? item.link : null"
        >
          <div class="menu-title">
            <span class="menu-icon bg-transparent">
              @if (item.iconUrl) {
              <div
                class="svg-mask"
                [ngClass]="item.isHovered || item.isSubItemClicked ? 'svg-mask-hover' : ''"
              ></div>
              } @else {
              <span
                class="material-icons"
                [ngClass]="
                  item.isHovered || item.isSubItemClicked
                    ? 'material-icons-rounded'
                    : 'material-icons-outlined'
                "
              >
                {{
                  (item.isHovered || item.isSubItemClicked) && item.iconUrlHover
                    ? item.iconUrlHover
                    : item.icon
                }}
              </span>
              }
            </span>
            <span class="menu-label">{{ item.label | translate }}</span>
          </div>
          @if (item.items?.length && item.actif) {
          <div
            class="submenu"
            [ngClass]="item.label === 'menu_paiement.payment' ? 'pdTopPayment' : ''"
          >
            @for (subItem of item.items; track subItem) {
            <div class="submenu-item">
              @if (subItem.title) {
              <div
                class="submenu-title"
                [routerLink]="subItem.link"
                (click)="handleSubItemClick(subItem, item)"
              >
                {{ subItem.title | translate }}
              </div>
              } @for (subSubItem of subItem.items; track subSubItem) {
              <div
                [class.submenu-subitem]="!subSubItem.iconColor"
                [class.submenu-subitem-color]="subSubItem.iconColor"
                (mouseenter)="hoveredItem = subSubItem"
                (mouseleave)="hoveredItem = null"
                (click)="handleSubItemClick(subSubItem, item)"
              >
                <span class="submenu-icon-{{ subSubItem.iconColor }}">
                  <i class="material-icons">{{ subSubItem.icon }}</i>
                  @if (subSubItem.iconUrl) {
                  <img [src]="subSubItem.iconUrl" />
                  }
                  <span class="submenu-label">{{ subSubItem.name | translate }}</span>
                </span>
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        } }
      </div>
    </div>
  </div>
</div>
